const input = document.createElement("input");

input.type = "file";
input.multiple = false;
input.accept = "image/jpeg";

let openFiles = Function.prototype;

input.onchange = (e) => {
  const files = e.target.files;
  const file = files && files[0];
  openFiles(file || null);
  e.target.value = "";
};

export function openFile() {
  return new Promise((resolve) => {
    openFiles = resolve;
    input.click();
  });
}
